import { useParams } from 'react-router-dom';
import SpotsManageCore from './SpotsManageCore';

const SpotsManage = () => {
  const { id } = useParams();
  return <SpotsManageCore storeId={id} embedded={false} />;
};

export default SpotsManage;
